import { flex } from 'hfty-styles/src/mixins'
import { primary, grey, orange, cream, white, black, error } from 'hfty-styles/src/colors'

const INDENT = '15px'

export const tool = {
  mask: {
    zIndex: 1,
  },
}

export const fields = {
  fieldsWrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    padding: 0,
    marginRight: INDENT,
  },
  select: {
    margin: 0,
  },
  dropZone: {
    padding: '45px 0',
    margin: `${INDENT} 0`,
    border: '2px dotted ' + primary(),
    fontSize: '.9em',
    letterSpacing: '.04em',
    color: grey(),
    backgroundColor: primary(0.1),
    cursor: 'pointer',
  },
  underlinedText: {
    textDecoration: 'underline',
  },
  centredText: {
    textAlign: 'center',
  },
  fileInfo: {
    ...flex('space-between'),
    padding: `0 11px 0 ${INDENT}`,
  },
  fileName: {
    marginRight: INDENT,
  },
  errorList: {
    marginBottom: INDENT,
  },
  warningWrapper: {
    padding: INDENT,
    marginBottom: INDENT,
    fontSize: '.857em',
    color: orange(),
    background: cream(),
  },
}

export const popup = {
  dialogWrapper: {
    background: white(),
  },
  dialogBody: {
    color: black(0.87),
  },
  errorsHolder: {
    lineHeight: '1.6em',
    color: error(),
  },
  errorsHeader: {
    marginBottom: '5px',
    fontSize: '1em',
    fontWeight: '500',
  },
  failedJobId: {
    marginRight: INDENT,
    fontWeight: '500',
  },
  button: {
    margin: '0 auto 16px',
  },
  topOffset: {
    marginTop: '20px',
  },
}
